import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import colors from "styles/colors";
import typography, { applyTypography } from "styles/typography";
import ImageButton from "../ImageButton";
import Text from "new_components/atoms/Text";
import { ICON_SET } from "new_components/atoms/Icon/IconSet";
import IconWithBackground from "../IconWithBackground";

// Styled Components
const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px;
  border-radius: 12px;
  background-color: ${colors.background.lightBlue};

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: fit-content;
  flex-direction: row;
  flex-shrink: 0;
  margin: 8px;
`;

const CardColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
  width: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  width: 100%;
`;

const PromptTitle = styled(Text)`
  color: ${colors.primary[500]};
  margin: 0;
  word-break: break-word;
  justify-content: flex-start;
  ${applyTypography(typography.smallText.semibold)}
`;

const PromptText = styled.p`
  color: ${colors.text.dark};
  margin: 0;
  word-break: break-word;
  ${applyTypography(typography.smallText.regular)}
`;

// Component
const PresetPromptCard = ({ prompt, clearPrompt }) => {
  return (
    <Card>
      <CardColumn>
        <IconWithBackground size={18} name={ICON_SET.aiIcon} />
        <PromptTitle>Prompt</PromptTitle>
        <TextContainer>
          <PromptText>{prompt}</PromptText>
        </TextContainer>
      </CardColumn>
      {clearPrompt && (
        <ImageButton
          textStyle
          icon={ICON_SET.clear}
          onClick={() => {
            clearPrompt();
          }}
        />
      )}
    </Card>
  );
};

PresetPromptCard.propTypes = {
  prompt: PropTypes.string.isRequired,
};

export default PresetPromptCard;
